import { IStockTakeItem } from './stock-take-item.interface';

/**
 * Meta document for chunked stock take items under a stock take.
 * Path: .../stock_takes/{stockTakeId}/items_meta/_meta
 */
export interface IStockTakeItemsMeta {
  chunkDocIds: string[];
  codeToChunkId: Record<string, string>;
  itemCount: number;
  schemaVersion: number;
}

/**
 * Chunk document storing many stock take line items keyed by encoded stock code.
 */
export interface IStockTakeItemChunkDoc {
  entries: Record<string, IStockTakeItemStored>;
  schemaVersion: number;
}

/**
 * Item payload stored inside a chunk (id derived from code in the app layer).
 */
export type IStockTakeItemStored = Omit<IStockTakeItem, 'id'>;
